import React, { useState } from 'react'
import SearchInput from './SearchInput'
import AccordionItem from './AccordionItem'

const AccordionList = [
   {
      id: 1,
      title: 'Course Content',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
   {
      id: 2,
      title: 'The Brief',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
   {
      id: 3,
      title: 'Type, Color & Icon Introduction',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
   {
      id: 4,
      title: 'Prototyping a App - Introduction',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
   {
      id: 5,
      title: 'Wireframe Feedback',
      lectures: '5 lectures • 87 min',
      items: [
         { id: 1, title: 'Introduction to the User Experience Course', preview: true, questions: '5 question', duration: '03:56' },
         { id: 2, title: 'Getting started with your Adobe XD project', preview: true, questions: '5 question', duration: '03:56' },
         { id: 3, title: 'What is UI vs UX - User Interface vs User Experience vs Product Designer', preview: true, questions: '5 question', duration: '03:56' },
         { id: 4, title: 'Wireframing (low fidelity) in Adobe XD', preview: true, questions: '5 question', duration: '03:56' },
         { id: 5, title: 'Viewing your prototype on a mobile device', preview: true, questions: '5 question', duration: '03:56' },
         { id: 6, title: 'Sharing your design', preview: true, questions: '5 question', duration: '03:56' }
      ]
   },
];

function SideBar({ course }) {
   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
   const [searchTerm, setSearchTerm] = useState('');

   const transformApiDataToSections = (courseData) => {
      if (!courseData?.modules) return AccordionList;

      return courseData.modules.map(module => ({
         id: module.id,
         title: module.title,
         lectures: `${module.lessons?.length || 0} lectures • ${module.estimated_duration_minutes || 0} min`,
         items: module.lessons?.map(lesson => ({
            id: lesson.id,
            title: lesson.title,
            preview: lesson.is_preview,
            duration: lesson.duration_minutes ? formatDuration(lesson.duration_minutes) : '00:00',
            contentType: lesson.content_type,
            contents: lesson.contents
         })) || []
      }));
   };

   // Formater la durée
   const formatDuration = (minutes) => {
      if (!minutes) return '00:00';
      const hrs = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return hrs > 0 ? `${hrs}:${mins.toString().padStart(2, '0')}` : `00:${mins.toString().padStart(2, '0')}`;
   };

   const filterSections = (sections, searchTerm) => {
      if (!searchTerm.trim()) return sections;

      return sections.map(section => ({
         ...section,
         items: section.items.filter(item =>
            item.title.toLowerCase().includes(searchTerm.toLowerCase())
         )
      })).filter(section => section.items.length > 0);
   };



   const sectionsData = transformApiDataToSections(course);
   const filteredSections = filterSections(sectionsData, searchTerm);

   return (
      <>
         {/* Bouton mobile pour ouvrir / fermer la sidebar */}
         <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="lg:hidden fixed bottom-4 right-4 bg-purple-1 text-white p-3 rounded-full z-30 shadow-lg"
         >
            {isSidebarOpen ? '×' : '☰'}
         </button>

         {/* Sidebar fixe */}
         <aside
            className={`fixed left-0 top-[92px] h-[calc(100vh-92px)] bg-light-3 text-dark-1 
  w-72 lg:w-[450px] p-4 z-20 shadow-md transform transition-transform duration-300
  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
         >
            {/* Contenu scrollable uniquement si nécessaire */}
            <div className="flex flex-col h-full">
               {/* Barre de recherche fixe en haut du sidebar */}
               <div className="flex-shrink-0 mb-4">
                  <SearchInput
                     value={searchTerm}
                     onChange={(e) => setSearchTerm(e.target.value)}
                     onClear={() => setSearchTerm('')}
                  />
               </div>

               {/* Zone scrollable */}
               <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
                  {filteredSections.map((elements, index) => (
                     <AccordionItem
                        key={index}
                        id={index}
                        title={elements.title}
                        items={elements.items}
                     />
                  ))}
               </div>
            </div>
         </aside>

      </>

   )
}

export default SideBar